import { render, staticRenderFns } from "./CalendarEventPopover.vue?vue&type=template&id=5ad679b0"
import script from "./CalendarEventPopover.vue?vue&type=script&lang=js"
export * from "./CalendarEventPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports